<div class="bmcore-field" [formGroup]="form">
  <label class="bmcore-field__label">
    @if (form.get(controlFormName).dirty) {
      <span>{{ title }}</span>
    }
    <input
      class="bmcore-field__input"
      type="{{ type }}"
      placeholder="{{ title }}"
      formControlName="{{ controlFormName }}"
      [ngClass]="{
        'bmcore-field__input--edit-profile': className === 'edit-profile',
        'bmcore-field__input--error': form.get(controlFormName).invalid && form.get(controlFormName).touched,
        'bmcore-field__input--active': form.get(controlFormName).dirty
      }"
    />
  </label>

  <!-- Errors -->
  @if (form.get(controlFormName).invalid && form.get(controlFormName).touched) {
    <div class="bm--common-error-message">
      <!-- Required field -->
      @if (form.get(controlFormName).errors['required']) {
        <p>
          {{ lg.forms.setEmptyErrorMessage(controlFormName) }}
        </p>
      }
      <!-- Email pattern field -->
      @if (controlFormName === 'email' && form.get('email').errors['pattern']) {
        <p>
          {{ lg.forms.invalidEmail }}
        </p>
      }
    </div>
  }
</div>
